export default "__VITE_ASSET__Zdjyg98K__"